angular.module("ainapp")
    .controller("UnitConvertionController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {




            $scope.PageName = "Unit Convertion";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.UnitConvertion = {
                    Quantity: "",
                    UnitId: "",
                    ConvertedUnitId: "",
                }

                $scope.HideProduct = false;
                if ($stateParams.ProductId > 0) {
                    $scope.UnitConvertion.ProductId = $stateParams.ProductId;
                } else {
                    $scope.HideProduct = true;
                    $scope.UnitConvertion.ProductId = 0;
                }

                $scope.load = 0;

                $scope.Units = [];
                MainService.UnitsInDropdown().then(function (response) {
                    $scope.Units = response.data;
                })


            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($stateParams.ProductId > 0) {
                            o.data.ProductId = $stateParams.ProductId;
                        } else {
                            $scope.HideProduct = true;
                            o.data.ProductId = 0;
                        }

                        MainService.UnitConvertionInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Quantity: {
                                type: "number",
                                editable: false,
                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            "ConvertedUnit.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },





                columns: [
                    {
                        field: "Product.Name",
                        title: "Product Name",
                        headerTemplate: "{{LanguageData.Product}}",
                        hidden: $scope.HideProduct,
                        },

                    {
                        field: "Unit.Name",
                        title: "Unit Name",
                        headerTemplate: "{{LanguageData.UnitName}}",

                        },
                    {
                        field: "ConvertedUnit.Name",
                        title: "ConvertedUnit Name",
                        headerTemplate: "{{LanguageData.ConvertedUnitName}}",
                        },
                    {
                        field: "Quantity",
                        title: "Quantity",
                        headerTemplate: "{{LanguageData.Quantity}}",

                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteUnitConvertion($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.UnitConvertion = data;
                //$scope.$apply();
            }

            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.UnitConvertion.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.UnitConvertion.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                    //                } else if ($scope.UnitConvertion.Name == "") {
                    //                    toastr.warning("Enter the Unit Name");
                } else if ($scope.UnitConvertion.CurrencyId == "") {
                    toastr.warning("Select Unit");

                } else if ($scope.UnitConvertion.ConvertedUnitId == "") {
                    toastr.warning("Select Converted Unit");


                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddUnitConvertion($scope.UnitConvertion).then(function (response) {
                        if (response.data == 1) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");
                            $scope.Init();
                            $scope.load = 0;
                        } else if (response.data == 2) {
                            toastr.error("Data Exist!");
                        } else {
                            toastr.error("Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

        }])
